$(function () {
    if ($('#ee-cutaway').length) {
        fixedWidth = 630;
    var app = window.app = new Vue({
      // delimiters: ['((', '))'],
        
      data: {
        scrollID: '',
        slideName: '',
        slickSlideIndex: 0,
        slickLastSlideIndex: 0,
        slideIndex: 0,
        iconIndexd: 0
      },

      computed: {
        slides: function () {
          var slideArray = [];
          var slides = $('#ee-cutaway--slider ul.slick-slider > li');

          slides.each(function () {
            var slideName = $(this).data('slide-name');
            slideArray.push(slideName);
          });
          return slideArray;
        }
      },

      watch: {
        scrollID: function (val) {
          this.iconIndex = val.substring(val.lastIndexOf("-") + 1, val.length);
          this.slideName = val.substr(0, val.lastIndexOf("-", val.length - 2)).substr(1);
          this.slideIndex = $('#ee-cutaway--slider li[data-slide-name="' + this.slideName + '"]:not(.slick-cloned)').index() - 1;
        }
      },

      methods: {
        isActiveSlide: function (slide) {
          return slide === this.slideName;
        },

        scrollToSlider: function (e) {
          var self = this;

          self.closePopUnders();
          // $('.popunder').css({'display' : ''});
          // $('.popunder-overlay').hide();
          // $('.popunder-close-button:visible').css({'display' : ''});

          this.scrollID = $(e.target).attr('href');

          Vue.nextTick(function () {
            $('html, body').animate({
              scrollTop: ($('#ee-cutaway--slider').offset().top - $('.nav--main').outerHeight())
            }, 500);

            self.goToSlide(self.slideIndex);
            setTimeout(function () {
              self.showPopUnder();
            }, 50);
          });
        },

        scrollToOptions: function () {
          $("html, body").animate({
            scrollTop: $("#ee-cutaway + .disclaimer + .four-column").offset().top - $('.nav--main').outerHeight()
          }, 500);
        },

        goToSlide: function (slideIndex) {
          var winWidth = $(window).width();
            if (winWidth >= fixedWidth) {
                $('#ee-cutaway--slider ul.slick-slider').slick('slickGoTo', slideIndex);
            } else if (winWidth <= fixedWidth) {
                $('#ee-cutaway--slider ul.slick-slider').slick('slickGoTo', slideIndex);
            }
        },

        initIcons: function (slick) {
          if (slick && slick.$slides && slick.$slides.length > 0) {
            this.slideName = $(slick.$slides[0]).data('slide-name');
            $('#ee-cutaway--slider .image-map-icons > li[data-slide-name="' + this.slideName + '"]').show();
          } else {
            $('#ee-cutaway--slider .image-map-icons > li[data-slide-name="' + this.slideName + '"]').show();
          }
        },

        showNextIcons: function (slick, currentSlide, nextSlide) {
          this.hideOldIcons();

          this.slideName = $(slick.$slides[nextSlide]).data('slide-name');
          Vue.nextTick(function () {
            $('#ee-cutaway--slider .image-map-icons > li[data-slide-name="' + $(slick.$slides[nextSlide]).data('slide-name') + '"]').show();
          });
        },

        hideOldIcons: function (e) {
          $('#ee-cutaway--slider .image-map-icons > li').hide();
        },

        showPopOver: function (e) {
          if ($(e.target).next().is(':visible')) {
            $(e.target).next().hide();
          } else {
            $(e.target).next().show();
          }
        },

        showPopUnder: function (e) {
          var winWidth = $(window).width();

            if (winWidth >= fixedWidth) {
            if (e && e.target) {
              if ($(e.target).next().is(':visible')) {
                $(e.target).parent().removeClass("active");
              } else {
                $(e.target).parent().addClass("active");
              }
            } else {
              $('#ee-cutaway--slider .image-map-icons li[data-slide-name="' + this.slideName + '"][data-icon-id="' + this.iconIndex + '"]').addClass("active");
            }
          } else {
            $('html,body').addClass('is-reveal-open');
            $('.popunder-overlay').show();
            if (e && e.target) {
              $(e.target).parent().addClass("active");
            } else {
                if ($('#ee-cutaway--slider .image-map-icons li[data-slide-name="' + this.slideName + '"][data-icon-id="' + this.iconIndex + '"]').length > 1) {
                    $($('#ee-cutaway--slider .image-map-icons li[data-slide-name="' + this.slideName + '"][data-icon-id="' + this.iconIndex + '"]')[0]).addClass("active");
                } else {
                    this.goToSlide(this.slideIndex);
                    $('#ee-cutaway--slider .image-map-icons li[data-slide-name="' + this.slideName + '"][data-icon-id="' + this.iconIndex + '"]').addClass("active");
                }
            }
            $('.popunder:visible').parent().find('.popunder-close-button').show();
          }
        },

        // showPopUnderById: function(e) {
        //     $('li[data-icon-id="'+this.iconIndex+'"] .popunder').show();
        // },

        closePopOvers: function (e) {
          if (e && e.target && $('.image-map-icons .popover').is(':visible') && $(e.target).is($('.image-map-icons > li > a'))) {
            $('.image-map-icons .popover').not($(e.target).next()).hide();
          } else if (e && e.target && !$(e.target).is($('.popover *'))) {
            $('.image-map-icons .popover').hide();
          }
        },

        closePopUnders: function (e) {
          var winWidth = $(window).width();
          var checkItems = $('.popunder, .popunder *, .popunder * *, .reveal-overlay, .reveal-overlay *, .reveal, .reveal * , .reveal .close-button, .reveal .close-button span, .donut-slider--feature, .donut-slider--feature *, .donut-slider--popunder-list ul, .donut-slider--popunder-list ul *, .donut-slider--popunder-list ul li *, .donut-slider--popunder-list ul li a, .donut-slider--popunder-list ul li a *');
          $('html,body').removeClass('is-reveal-open');
          // if($(e.target).is($('.popunder, .popunder * , .popunder * * , .reveal-overlay, .reveal-overlay * , .reveal, .reveal * , .reveal .close-button, .reveal .close-button span')) ) {
          // }
            if (winWidth >= fixedWidth) {
            if (e && e.target && $('.popunder').is(':visible') && !$(e.target).is(checkItems)) {
              $('.popunder').not($(e.target).next()).parent().removeClass("active");
              $('.popunder').css({
                'display': ''
              });
              $('.popunder-overlay').hide();
              $('.popunder-close-button:visible').css({
                'display': ''
              });
            } else if (e && e.target && !$(e.target).is(checkItems)) {
              $('.popunder').parent().removeClass("active");
              $('.popunder').css({
                'display': ''
              });
              $('.popunder-overlay').hide();
              $('.popunder-close-button:visible').css({
                'display': ''
              });
            }
            if (e && e.target && $(e.target).is('.donut-slider--popunder-list .popunder ul li a')) {
              $('.image-map-icons .popunder').not($(e.target).next()).parent().removeClass("active");
              $('.image-map-icons .popunder').css({
                'display': ''
              });
              $('.image-map-icons .popunder-overlay').hide();
              $('.image-map-icons .popunder-close-button:visible').css({
                'display': ''
              });
            }
            } else if (winWidth < fixedWidth) {
            if (e && e.target && $('.popunder').is(':visible') && !$(e.target).is($('.popunder').prev("a")) && !$(e.target).is(checkItems)) {
              $('.popunder:visible').parent().removeClass("active");
              $('.popunder').css({
                'display': ''
              });
              $('.popunder-overlay').hide();
              $('.popunder-close-button:visible').css({
                'display': ''
              });
            }
          }
        },

        slickify: function () {
          var self = this,
            slider = $('#ee-cutaway--slick-slider'),
            donutSlider = $('#donut-slider--slides'),
            donutImgSlider = $('#ee-donut-slider'),
            donutImgSliderHover = $('#ee-donut-slider-hover'),
            winWidth = $(window).width();

            if ((winWidth >= fixedWidth) && !slider.hasClass('slick-initialized')) {
                self.moveIcons();

                // initial slick callback
                slider.on('init', function (event, slick) {
                    slick.$slider.find('.slick-dots').attr('aria-hidden', true);
                    slick.$slider.find('.slick-dots li, .slick-dots button').attr('tabindex', -1);
                    self.initIcons(slick);
                });
                slider.slick({
                    adaptiveHeight: true,
                    dots: true,
                    arrows: true,
                    speed: 0,
                    swipe: true,
                    prevArrow: '<button type="button" class="slick-prev"><span class="show-for-sr">Previous Slide</span><img src="/etc/icons/icon-left-white.png" alt="Next Slide"></button>',
                    nextArrow: '<button type="button" class="slick-next"><span class="show-for-sr">Next Slide</span><img src="/etc/icons/icon-right-white.png" alt="Next Slide"></button>'
                });

                var label = slider.attr('aria-label');
                slider.find('.slick-track').attr('aria-label', label);
                slider.attr('aria-label', '').removeAttr('aria-label');
                $('.slick-slide, .slick-dots li').removeAttr('role');

                donutSlider.slick({
                    swipe: false,
                    asNavFor: '#ee-donut-slider',
                    appendArrows: $('.donut-arrow-buttons'),
                    prevArrow: '<button type="button" class="slick-prev"><span class="show-for-sr">Previous Slide</span><img src="/etc/icons/icon-left-white.png" alt="Next Slide"></button>',
                    nextArrow: '<button type="button" class="slick-next"><span class="show-for-sr">Next Slide</span><img src="/etc/icons/icon-right-white.png" alt="Next Slide"></button>',
                    dots: false
                });

                donutImgSlider.slick({
                    swipe: false,
                    arrows: false,
                    dots: false,
                    fade: true,
                    asNavFor: '#donut-slider--slides',
                });
            } else if (winWidth >= fixedWidth && slider.hasClass('slick-initialized')) {
                slider.not('.slick-initialized').slick({
                    adaptiveHeight: true,
                    dots: true,
                    arrows: true,
                    speed: 0,
                    swipe: true,
                    prevArrow: '<button type="button" class="slick-prev"><span class="show-for-sr">Previous Slide</span><img src="/etc/icons/icon-left-white.png" alt="Next Slide"></button>',
                    nextArrow: '<button type="button" class="slick-next"><span class="show-for-sr">Next Slide</span><img src="/etc/icons/icon-right-white.png" alt="Next Slide"></button>'
                });
                donutSlider.not('.slick-initialized').slick({
                    swipe: false,
                    asNavFor: '#ee-donut-slider',
                    appendArrows: $('.donut-arrow-buttons'),
                    prevArrow: '<button type="button" class="slick-prev"><span class="show-for-sr">Previous Slide</span><img src="/etc/icons/icon-left-white.png" alt="Next Slide"></button>',
                    nextArrow: '<button type="button" class="slick-next"><span class="show-for-sr">Next Slide</span><img src="/etc/icons/icon-right-white.png" alt="Next Slide"></button>',
                    dots: false
                });

                donutImgSlider.not('.slick-initialized').slick({
                    swipe: false,
                    arrows: false,
                    dots: false,
                    fade: true,
                    asNavFor: '#donut-slider--slides',
                });
            } else if (winWidth < fixedWidth && !slider.hasClass('slick-initialized')) {
                
                
                // initial slick callback               
                slider.on('init', function (event, slick) {
                    slick.$slider.find('.slick-dots').attr('aria-hidden', true);
                    slick.$slider.find('.slick-dots li, .slick-dots button').attr('tabindex', -1);
                    self.initIcons(slick);
                }); 

                slider.slick({
                    adaptiveHeight: true,
                    dots: true,
                    arrows: false,
                    speed: 0,
                    swipe: true,
                    cssEase: 'linear'
                });
                var label = slider.attr('aria-label');
                slider.find('.slick-track').attr('aria-label', label);
                slider.attr('aria-label', '').removeAttr('aria-label');
                $('.slick-slide, .slick-dots li').removeAttr('role');
                $(document).ready(function () {
                    self.moveIcons();
                    self.goToSlide(0);
                });
            } else if (winWidth < fixedWidth && slider.hasClass('slick-initialized')) {
                
                slider.not('.slick-initialized').slick({
                    adaptiveHeight: true,
                    dots: true,
                    arrows: false,
                    speed: 0,
                    swipe: true,
                    cssEase: 'linear'
                });
                donutSlider.slick("unslick");
                donutImgSlider.slick("unslick");  
                self.moveIcons();
                self.goToSlide(0);
            }

          // On before slide change
          slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            self.slickSlideIndex = nextSlide;
            self.slickLastSlideIndex = currentSlide;
            self.showNextIcons(slick, currentSlide, nextSlide);
          });
        },

        moveIcons: function () {
          // var self = this;
          // var slider = $('#ee-cutaway--slick-slider');
            var slides = $('#ee-cutaway--slick-slider > li[data-slide-name]');
           
          var winWidth = $(window).width();
          var icons;

            if (winWidth < fixedWidth && $('#ee-cutaway--container > .image-map-icons > li[data-slide-name]').length > 0) {
            icons = $('#ee-cutaway--container > .image-map-icons > li[data-slide-name]');
            icons.show();

            slides.each(function () {
              var slide = $(this);
              // var slideName = slide.data('slide-name');

              if (slide.find("ul.image-map-icons").length === 0) {
                slide.find(".slide-content").append('<ul class="image-map-icons"></ul>');
              }

              icons.each(function (index) {
                var slideName = $(slide).data('slide-name'),
                  iconSlideName = $(this).data('slide-name');

                if (slideName === iconSlideName) {
                  $(slide).find('ul.image-map-icons').append($(this));
                }
              }, slide);
            });
                this.hideOldIcons();
            } else if (winWidth >= fixedWidth && $('.slide-content > .image-map-icons > li[data-slide-name]').length > 0) {
            icons = $('.slide-content > .image-map-icons > li[data-slide-name]');

            slides.each(function () {
              icons.each(function (index) {
                $('#ee-cutaway--container > .image-map-icons').append($(this));
              });
            });

            this.hideOldIcons();
          }
        },

        showHideAccordionItem: function (e) {
          var self = this,
            clicked = $(e.target),
            items = $('#donut-slider--slides li');

          $('#donut-slider--slides li .donut-slider--content:visible').slideUp(250);

          if ($(e.target).closest('#donut-slider--slides li').hasClass('active')) {
            $(e.target).closest('#donut-slider--slides li').find('.donut-slider--content').slideUp(250, function () {
              items.removeClass('active');
            });
          } else {
            items.removeClass('active');
            $(e.target).closest('#donut-slider--slides li').find('.donut-slider--content').slideDown(250, function () {
              $(e.target).closest('#donut-slider--slides li').addClass('active');

              setTimeout(function () {
                $('body, html').animate({
                  scrollTop: $('#donut-slider--slides li.active').offset().top - $('.nav--bottom').height()
                });
              }, 50);
            });
          }
        }
      },

      created: function () {},

      mounted: function () {
        var self = this,
          slider = $('#ee-cutaway--slick-slider'),
          donutSlider = $('#donut-slider--slides'),
          donutImgSlider = $('#ee-donut-slider');

        self.slickify();

        $('body').on('click', '#ee-donut-mask li a', function (e) {
          e.preventDefault();
          var buttonIndex = $(this).parent().index();
          if (buttonIndex === 2) {
            buttonIndex = 3;
          } else if (buttonIndex === 3) {
            buttonIndex = 2;
          }
          donutSlider.slick('slickGoTo', buttonIndex);
        });
        $("#ee-donut-mask li a").on({
          mouseenter: function () {
            if ($(window).width() > 1024) {
              var maskhoverIndex = $(this).parent().index();
              if (maskhoverIndex === 2) {
                maskhoverIndex = 3;
              } else if (maskhoverIndex === 3) {
                maskhoverIndex = 2;
              }

              maskhoverIndex++;
              $("#ee-donut-slider-hover img").hide();
              $("#ee-donut-slider li img:nth-child(2)").hide();
              $("#ee-donut-slider-hover img:nth-child(" + maskhoverIndex + ")").show();
            }
          },
          mouseleave: function () {
            if ($(window).width() > 1024) {
              $("#ee-donut-slider-hover img").hide();
              $("#ee-donut-slider li img:nth-child(2)").show();
            }
          }
        });
        $('body').on('click', '.donut-slider--feature, .donut-slider--feature span, .donut-slider--feature img', function (e) {
          e.preventDefault();

          var self = ($(this).hasClass('donut-slider--feature')) ? $(this) : $(this).closest('.donut-slider--feature');
            var features = ($(window).width() >= fixedWidth) ? $('.slick-slide:not(.slick-cloned) .donut-slider--feature') : $('#donut-slider--slides  .donut-slider--feature');
          var featurePopunders = $('.donut-slider--popunder-list .popunder');

          var curIndex = features.index(self);
          var featurePopunderIndex = featurePopunders.eq(curIndex);

          featurePopunders.hide();
          featurePopunderIndex.show();
            if ($(window).width() < fixedWidth) {
            featurePopunderIndex.parent().find('.popunder-close-button').show();
          }
        });

        $(window).resize(function () {
          self.slickify();

          self.closePopUnders();
          $('.popunder:visible').parent().removeClass("active");
          $('.popunder').css({
            'display': ''
          });
          $('.popunder-overlay').hide();
          $('.popunder-close-button:visible').css({
            'display': ''
          });
        });
        self.moveIcons();

        $(document).on('click vclick', 'body', function (e) {
            if ($(window).width() >= fixedWidth || $(e.target).hasClass('popunder-overlay') || $(e.target).hasClass('popunder-close-button') || $(e.target).parents('.popunder-close-button').length) {
            if (e.target.href && e.target.href.indexOf('#') === -1) {
              window.location = e.target.href;
            }

            if ($('.popover').is(':visible')) self.closePopOvers(e);
            if ($('.popunder').is(':visible')) self.closePopUnders(e);
          }
        });
      }
    });

    app.$mount('#ee-cutaway');
  }
});